var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "booking-order-table" },
    [
      _c(
        "el-form",
        {
          staticClass: "search-form",
          attrs: { inline: true, model: _vm.searchForm },
        },
        [
          _c(
            "el-form-item",
            [
              _c("el-input", {
                attrs: { placeholder: "请输入用户手机号", clearable: "" },
                model: {
                  value: _vm.searchForm.phone,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchForm, "phone", $$v)
                  },
                  expression: "searchForm.phone",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c("el-input", {
                attrs: { placeholder: "请输入订单号", clearable: "" },
                model: {
                  value: _vm.searchForm.orderNo,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchForm, "orderNo", $$v)
                  },
                  expression: "searchForm.orderNo",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c("el-input", {
                attrs: { placeholder: "请输入预定人姓名", clearable: "" },
                model: {
                  value: _vm.searchForm.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchForm, "name", $$v)
                  },
                  expression: "searchForm.name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "150px" },
                  attrs: { placeholder: "订单状态", clearable: "" },
                  model: {
                    value: _vm.searchForm.orderStatus,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "orderStatus", $$v)
                    },
                    expression: "searchForm.orderStatus",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "全部", value: null } }),
                  _vm._v(" "),
                  _c("el-option", { attrs: { label: "已确认", value: 1 } }),
                  _vm._v(" "),
                  _c("el-option", { attrs: { label: "已下单", value: 2 } }),
                  _vm._v(" "),
                  _c("el-option", { attrs: { label: "已核销", value: 3 } }),
                  _vm._v(" "),
                  _c("el-option", { attrs: { label: "已退单", value: 4 } }),
                  _vm._v(" "),
                  _c("el-option", { attrs: { label: "已结单", value: 7 } }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "200px" },
                  attrs: {
                    placeholder: "选择门店",
                    clearable: "",
                    filterable: "",
                  },
                  model: {
                    value: _vm.searchForm.shopId,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "shopId", $$v)
                    },
                    expression: "searchForm.shopId",
                  },
                },
                _vm._l(_vm.shopList, function (shop) {
                  return _c("el-option", {
                    key: shop.storeId,
                    attrs: { label: shop.storeName, value: shop.storeId },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c("el-input", {
                attrs: { placeholder: "商品标题", clearable: "" },
                model: {
                  value: _vm.searchForm.goodsTitle,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchForm, "goodsTitle", $$v)
                  },
                  expression: "searchForm.goodsTitle",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSearch } },
                [_vm._v("搜索")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "info" }, on: { click: _vm.handleDownload } },
                [_vm._v("下载")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableData, border: "" },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "orderSn",
              label: "订单编号",
              width: "180",
              fixed: "left",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "用户id/用户手机号", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.userId || "--") +
                        "/" +
                        _vm._s(scope.row.phone || "--") +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "storeName", label: "门店", width: "200" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "addTime", label: "下单时间", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.formatDate(scope.row.addTime)) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "预约时间", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _vm._v(_vm._s(_vm.formatBookingDateTime(scope.row))),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(_vm._s(_vm.formatBookingTimePeriod(scope.row))),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "orderGoodsInfoList",
              label: "预定内容",
              align: "center",
              width: "200",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return _vm._l(
                    scope.row.orderGoodsInfoList,
                    function (item, idx) {
                      return _c("div", { key: item.id || idx }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(idx + 1) +
                            "." +
                            _vm._s(item.goods_name) +
                            " x" +
                            _vm._s(item.num) +
                            "\n        "
                        ),
                      ])
                    }
                  )
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "auditCode", label: "核销码", width: "100" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "auditTime", label: "核销时间", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          scope.row.auditTime
                            ? _vm.formatDate(scope.row.auditTime)
                            : "--"
                        ) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "orderAmount",
              label: "订单金额",
              width: "100",
              formatter: _vm.formatPrice,
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "surplus",
              label: "余额",
              width: "100",
              formatter: _vm.formatPrice,
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "money",
              label: "支付",
              width: "100",
              formatter: _vm.formatPrice,
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "状态", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _c("span", [
                        _vm._v(
                          "订单: " +
                            _vm._s(
                              _vm.getOrderStatusText(scope.row.orderStatus)
                            )
                        ),
                      ]),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          "支付: " +
                            _vm._s(_vm.getPayStatusText(scope.row.payStatus))
                        ),
                      ]),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          "退款: " +
                            _vm._s(
                              _vm.getReturnStatusText(scope.row.returnStatus)
                            )
                        ),
                      ]),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "invoiceStatus", label: "发票状态", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.getInvoiceStatusText(scope.row.invoiceStatus)
                        ) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm.showWriteOffButton(scope.row)
                      ? _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.writeOff(scope.row)
                              },
                            },
                          },
                          [_vm._v("\n          核销\n        ")]
                        )
                      : _c("span", [_vm._v("—")]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.pagination.currentPage,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.pagination.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.pagination.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }